import React, { useContext } from 'react'
import { Navigate, Route, Routes, useNavigate } from 'react-router'
import {
	NotFoundPage,
	PrivateRoute,
	AuthContext,
	IdleTimeOutModal,
	MaintenanceContextProvider,
} from 'shared/index'
import { appRoutes } from '../../constants/routes'
import NorwegianBankIdCallbackPage from './NorwegianBankIdCallbackPage'
import { StartPage } from './StartPage'
import LoginPage from '../LoginPage/LoginPage'
import LogoutPage from '../LogoutPage/LogoutPage'
import LogoutCallbackPage from '../LogoutPage/LogoutCallbackPage'
import GermanyAuthentication from './GermanyAuthentication'
import CardApplicationPage from '../Applications/CardApplicationPage/CardApplicationPage'
import IdleTimer from 'react-idle-timer'
import { idleTimerService, ITimer } from 'shared/services/idleTimerService'
import { SspContextProvider } from 'selfServicePortal/contexts/SspContext'
import RevokeContactChange from '../RevokeContactChange/RevokeContactChange'
import CallbackPage from '../CallbackPage'
import PaymentVerification from '../PaymentVerification/PaymentVerification'

function RootRoute() {
	const [timer, setTimer] = React.useState<ITimer>({
		timeout: 60000 * 15 * 1, //15 minutes
		showModal: false,
		userLoggedIn: false,
		isTimedOut: false,
		counter: 60, //seconds
	})
	const navigate = useNavigate()
	const idleTimer = React.useRef<IdleTimer>(new IdleTimer(timer))

	const { isAuthenticated } = useContext(AuthContext)
	return (
		<>
			{isAuthenticated ? (
				<IdleTimer
					ref={idleTimer as any}
					onActive={() => idleTimerService.onActive}
					onAction={() => idleTimerService.onAction}
					onIdle={() => idleTimerService.onIdle(setTimer, timer)}
					element={document}
					debounce={250}
					timeout={timer.timeout}
					stopOnIdle={true}
				/>
			) : (
				<></>
			)}
			{/* Before changes read https://reactrouter.com/web/guides/quick-start */}
			<Routes>
				<Route
					path={appRoutes.login}
					element={
						isAuthenticated ? (
							<Navigate to={appRoutes.startpage} />
						) : (
							<LoginPage />
						)
					}
				/>
				<Route path={appRoutes.logout} element={<LogoutPage />} />
				<Route
					path={appRoutes.logoutcallback}
					element={<LogoutCallbackPage />}
				/>
				<Route
					path={appRoutes.callbackPage}
					element={<CallbackPage />}
				/>
				<Route
					path={appRoutes.norwegianBankIdCallback}
					element={<NorwegianBankIdCallbackPage />}
				/>
				<Route
					path={appRoutes.revokeaddresschange}
					element={<RevokeContactChange />}
				/>

				<Route
					path={appRoutes.paymentVerification}
					element={<PaymentVerification />}
				/>

				<Route
					path={appRoutes.cardApplicationPage}
					element={
						<PrivateRoute
							path={appRoutes.cardApplicationPage}
							component={CardApplicationPage}
							redirect={appRoutes.cardApplicationLogin}
						/>
					}
				/>
				<Route
					path={appRoutes.cardApplicationLogin}
					element={
						isAuthenticated ? (
							<Navigate to={appRoutes.cardApplicationPage} />
						) : (
							<GermanyAuthentication />
						)
					}
				/>
				{/*Important: A route with path="/" will *always* match
				the URL because all URLs begin with a /. So that's
				why we put this one last of all */}
				{/* {appConfig.country === 'de' && ( */}

				<Route
					path={appRoutes.sepadirectdebit}
					element={
						<SspContextProvider>
							<PrivateRoute
								path={appRoutes.sepadirectdebit}
								component={StartPage}
								redirect={appRoutes.login}
							/>
						</SspContextProvider>
					}
				/>

				<Route
					path={appRoutes.referfriends}
					element={
						<SspContextProvider>
							<PrivateRoute
								path={appRoutes.referfriends}
								component={StartPage}
								redirect={appRoutes.login}
							/>
						</SspContextProvider>
					}
				/>

				<Route
					path={appRoutes.startpage}
					element={
						<SspContextProvider>
							<PrivateRoute
								path={appRoutes.startpage}
								component={StartPage}
								redirect={appRoutes.login}
							/>
						</SspContextProvider>
					}
				/>

				{/* //Default route*/}
				<Route element={<NotFoundPage />} />
			</Routes>

			<IdleTimeOutModal
				showModal={timer.showModal}
				handleClose={() =>
					idleTimerService.handleClose(idleTimer, setTimer)
				}
				handleLogout={() =>
					idleTimerService.handleLogout(navigate, setTimer)
				}
				remainingTime={timer.counter}
			/>
			{isAuthenticated ? (
				<div className="authMaintenance">
					<MaintenanceContextProvider />
				</div>
			) : (
				<div className="nonAuthMaintenance">
					<MaintenanceContextProvider />
				</div>
			)}
		</>
	)
}

export default RootRoute
